import { createContext } from 'react'

import { DialogWidth } from './types'

type DialogContextValue = {
    width: DialogWidth
    fullHeight?: boolean
    noPadding?: boolean
    close: (value?: any) => void
}

export const DialogContext = createContext<DialogContextValue>(undefined as any)
